<template>
  <div class="sv-block">
    <div class="sv-header">
      <span class="sv-title">
        <i class="bx bx-chair mr-2" style="color:#556ee6"></i>Vagas por grupo
        <span class="sv-mode-badge" :title="modeTooltip">{{ modeLabel }}</span>
      </span>
    </div>

    <!-- Lista por grupo -->
    <div class="sv-groups">
      <div class="sv-group" v-for="g in data.groups" :key="g.id">
        <div class="sv-group-top">
          <span class="sv-group-name">{{ g.name }}</span>
          <span class="sv-group-count">
            {{ formatNumber(g.occupied) }} / {{ formatNumber(g.limit) }} ocupadas
            <span v-if="g.is_full" class="sv-full-tag">cheio</span>
          </span>
        </div>
        <div class="sv-group-bar-track">
          <div
            class="sv-group-bar-fill"
            :class="barClass(g.percentage)"
            :style="{ width: Math.min(g.percentage || 0, 100) + '%' }"
          ></div>
        </div>
        <div class="sv-group-meta">
          <span class="sv-meta-item" style="color:#34c38f">
            <i class="bx bx-check-circle"></i> {{ formatNumber(g.free) }} livres
          </span>
          <span class="sv-meta-item" v-if="g.waiting > 0" style="color:#f1b44c">
            <i class="bx bx-time-five"></i> {{ formatNumber(g.waiting) }} em lista de espera
          </span>
          <span class="sv-meta-item" v-if="g.review > 0" style="color:#50a5f1">
            <i class="bx bx-search-alt"></i> {{ formatNumber(g.review) }} em análise
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartVacancyGroups',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    modeLabel () {
      return this.data.count_mode === 'confirmed' ? 'Confirmados' : 'Inscritos'
    },
    modeTooltip () {
      return this.data.count_mode === 'confirmed'
        ? 'A ocupação conta apenas participantes Confirmados.'
        : 'A ocupação conta qualquer inscrição em andamento (inclui pendentes e em análise).'
    }
  },
  methods: {
    formatNumber (n) {
      return (n || 0).toLocaleString('pt-BR')
    },
    barClass (pct) {
      if (pct === null || pct === undefined) return 'sv-bar--ok'
      if (pct >= 100) return 'sv-bar--full'
      if (pct >= 85) return 'sv-bar--warning'
      return 'sv-bar--ok'
    }
  }
}
</script>

<style scoped>
.sv-block {
  background: #fff;
  border: 1px solid #eaecf2;
  border-radius: 5px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(26, 29, 38, 0.04);
  margin-bottom: 24px;
}

.sv-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  flex-wrap: wrap;
  gap: 8px;
}

.sv-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d26;
  display: flex;
  align-items: center;
}

.sv-mode-badge {
  margin-left: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #556ee6;
  background: #eef1fd;
  border-radius: 4px;
  padding: 3px 8px;
}

/* Lista por grupo */
.sv-groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sv-group {
  border-bottom: 1px solid #f0f1f6;
  padding-bottom: 16px;
}
.sv-group:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.sv-group-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
  gap: 8px;
}

.sv-group-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a1d26;
}

.sv-group-count {
  font-size: 12px;
  font-weight: 600;
  color: #6c7293;
  white-space: nowrap;
}

.sv-full-tag {
  margin-left: 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #f46a6a;
  background: #fdecec;
  border-radius: 3px;
  padding: 2px 6px;
}

.sv-group-bar-track {
  height: 8px;
  background: #e7eaf3;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 8px;
}

.sv-group-bar-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
}

.sv-bar--ok { background: #34c38f; }
.sv-bar--warning { background: #f1b44c; }
.sv-bar--full { background: #f46a6a; }

.sv-group-meta {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
}

.sv-meta-item {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.sv-meta-item i {
  font-size: 14px;
}
</style>
